import { render } from "./VTask.vue?vue&type=template&id=3564739f"
import script from "./VTask.vue?vue&type=script&lang=js"
export * from "./VTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__